export const historyData = [{
        title: "Création de Cartésia Junior",
        content: "Deux étudiants en informatique de l'IUT Paris Descartes décident de se lancer dans un concept de Junior Entreprise, afin de mettre à profit de manière concrète les meilleurs talents de notre campus.",
        date: "2018",
    },
    {
        title: "Démarrage avec le Starter (2e génération)",
        content: "Créer un tel projet nécessite un grand nombre de démarches, et donc, du suivi par des personnes compêtantes. Le starter de l'IUT de Paris nous a grandement aidé à concrétiser notre idée.",
        date: "2019",
    },
    {
        title: "Troisième génération de Cartésia",
        content: "Un groupe d'étudiants se sont réunis pour assurer la continuité des activités de l'association. Malhereusement, la crise sanitaire n'a pas permi à Cartésia de se développer pleinement durant l'année scolaire.",
        date: "2020",
    },
    {
        title: "Statut d'association à but non lucratif obtenu",
        content: "Être reconnu officiellement comme association étudiante est nécessaire pour obtenir le statut de Junior Entreprise. Sans ce statut, il n'est pas possible d'effectuer de prestations, donc enfin une bonne chose de faite !",
        date: "2020",
    },
    {
        title: "Quatrième génération de Cartésia",
        content: "Cinq étudiants ont pris la relève exécutive de l'association. Motivés à raviver la flamme après deux ans de crise sanitaire, une organisation a été menée pour complètement repenser la stratégie de l'entreprise.",
        date: "2021",
    },
    {
        title: "Statut de Junior Entreprise ?",
        content: "Coming soon... Restez attentifs sur nos réseaux sociaux !",
        date: "2021",
    },
]